module.exports = __webpack_public_path__ + "img/Still-Thinking-Inspect-Small.fae543c0.png";